import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import { fetchS3Photos, uploadSinglePhoto } from '../../utils/awsHelper';

/**
 * @class
 *
 * PhotoPack page.
 */
const SiteSurveyPhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.opportunityId;
    sessId = this.props.sessId;
    type = this.props.type;
    s3;
    username = this.props.user.name;
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    postRequestOpp = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Company__c"
        ],
        "where": {
            "Id": this.opportunityId
        }
    };

    postRequestSession = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Field_Job__c",
            "Field_Job__r.Clocked_End__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    postRequestWorkOrder = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Assigned_Field_Team__c", 
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    state = {
        preview: false,
        previewPic: {},
        previewPics: [],
        filesToUpload: [],
        uploading: false,
        fileUploadCounter: 0,
        errorMessage: '',
        opp: {},
        session: {},
        slackResponse: '',
        sendingToSlack: false,
        isWorkOrder: false,

        HouseFrontAndAddress: {},
        HouseFrontAndAddressError: false,
        HouseFrontAndAddressArray: [],

        AtticAndRaftersArray: [],
        AtticAndRaftersError: false,

        TiltScreenshot: {},
        TiltScreenshotError: false,
        TiltScreenshotArray: [],

        SubPanelArray: [],
        SubPanelError: false,

        GarageArray: [],
        GarageError: false,

        Ceiling: {},
        CeilingError: false,

        MSPStandbackAndWeatherheadArray: [],
        MSPStandbackAndWeatherheadError: false,

        GasRiserMeasurement: {},
        GasRiserMeasurementError: false,

        MeterCloseUp: {},
        MeterCloseUpError: false,
        MeterCloseUpArray: [],

        MSPCloseUpsArray: [],
        MSPCloseUpsError: false,

        WholeHouseWallSpaceArray: [],
        WholeHouseWallSpaceError: false,

        BatteryClearanceMeasurement: {},
        BatteryClearanceMeasurementError: false,
        BatteryClearanceMeasurementArray: [],

        ExteriorGrounding: {},
        ExteriorGroundingError: false,
        ExteriorGroundingArray: [],

        RoofAndHorizonPhotosArray: [],
        RoofAndHorizonPhotosError: false,

        GroundMountAreaArray: [],
        GroundMountAreaError: false,

        GroundMountVideo: {},
        GroundMountVideoError: false,
        
        TrenchPathArray: [],
        TrenchPathError: false,

        MisceallaneousArray: [],
        MisceallaneousError: false,

        DigTicketMarking: {},
        DigTicketMarkingError: false,
        DigTicketMarkingArray: []
    }

    // ---------- life cycle methods: ----------
     async componentDidMount() {
        window.scrollTo(0, 0);

        fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + this.type,
            process: 'getDocs',
            existingState: this.state,
            source: this.source
        })
        .then(newState => {
            this.setState(newState);
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });

        await this.getOpp();

        const isWorkOrder = this.sessId.startsWith('a0j');
        this.setState({ isWorkOrder });

        if (isWorkOrder) {
            await this.getWorkOrder();
        } else {
            await this.getSession();
        }
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getOpp = async() => {
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpp,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // the post request is limited by 1 (since we only want a single record), we get the first item in records array:
                const data = res.data.records[0];
                this.setState({opp: data});
            })
            .catch(err => console.log('POST Error Opp:\n', err));
    };

    getSession = async() => {
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSession,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    };

    getWorkOrder = async() => {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postRequestWorkOrder,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    }

    capturePhoto = async(file, stateName, stateNameError) => {
        if (!file || this.state.uploading) return;
                
        try {
            await uploadSinglePhoto({
                file,
                stateName,
                stateNameError,
                username: this.username,
                opportunityId: this.opportunityId,
                type: this.type,
                setState: this.setState.bind(this),
                source: this.source
            });
        } catch(err){
            console.log(err)
        }
    };

    bulkUpload = async (files, arrayName, picNames, stateNameError) => {
        const currentArray = this.state[arrayName] || [];
        const updatedArray = [...currentArray];
        const fileArray = Array.from(files);
        let nextNumber = updatedArray.length + 1;

        this.setState({
            bulkUploading: true,
            uploadProgress: { done: 0, total: fileArray.length },
            errorMessage: ''
        });

        try {
            for (const file of fileArray) {
                const picName = `${picNames}${nextNumber}`;

                try {
                    await this.capturePhoto(file, picName, stateNameError);
                    updatedArray.push(picName);
                    nextNumber++;
                } catch (err) {
                    console.error(`Failed to upload ${picName}:`, err);
                } finally {
                    // update progress after each attempt
                    this.setState(prev => ({
                        uploadProgress: {
                            done: Math.min((prev.uploadProgress?.done || 0) + 1, fileArray.length),
                            total: fileArray.length
                        }
                    }));
                }
            }
            this.setState({ [arrayName]: updatedArray });
        } finally {
            this.setState({ bulkUploading: false });
        }
    };

    previewImage = (e) => {
        let img = e;
        this.setState({previewPic: img, preview:true});
    };

    addAnotherPic = (array, fileName, displayName) => {
        let picNumber = this.state[array].length + 1;
        let stateName = fileName + picNumber.toString()
        this.setState({
            [array]: [...this.state[array], stateName],
            [stateName] : {}
        })
    };

    sendToSlack = () => {
        this.setState({sendingToSlack: true});

        let message = 'Site Survey Photos Review for: <https://v3electric.my.site.com/frontendOps/s/detail/' +  this.state.opp.Id + '|' +  this.state.opp.Name +'>\n' +
            'Field Tech: ' + this.props.user.name + '\n' +
            'Photo Pack Page: <https://v3electric.my.site.com/frontendOps/s/sfdcpage/%2Fapex%2FPhotoPackOppS3%3F%26id%3D' + this.state.opp.Id + '|Photo Pack>\n' +
            'Work Order: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.session.Id + '|' +  this.state.session.Name +'>\n' +
            'Financier: ' + this.state.opp.Company__c;

        // Channel is #install-completion-review
        // test-api channel id C06JN84MGFM
        let payload = {
            "channel": "C06HN5SJRJ4",
            // "channel": 'C06JN84MGFM',
            "text": message
        };

        axios.post(
            '/slackMessage', 
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({slackResponse: 'Notification sent to Slack successfully', sendingToSlack: false});
            })
            .catch(err => {
                console.log('POST Error Sending Slack Message:\n', err);
                this.setState({slackResponse: 'Failed to send to Slack: ' + err.message, sendingToSlack: false});
            });
    };

    render() {
        return (
            <div className={css.PhotoPack}>
                <h1 className='pb-3'>Site Survey Photo Pack</h1>
                <h2 className='text-white pb-3'>Please Ensure HEIC is turned off as the format isn't readily sharable</h2>
                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>
                
                {
                    this.state.preview ? 
                    <div>
                        <div>
                            <img className={css.PhotoPack__PreviewImg} src={this.state.previewPic} alt="Preview of upload" />
                        </div>
                        <div className='pt-3'>
                            <button className='btn btn-primary' onClick={() => this.setState({preview: false, previewPic: {}})}>Close Preview</button>
                        </div>
                    </div>

                    :

                    <div>
                        {/* Slack div to send messages */}
                        {/* <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div> */}

                        <table>
                            <tbody>

                                {/* House Front And Address Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.HouseFrontAndAddress).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> House Front And Address</div>
                                            :
                                            this.state.HouseFrontAndAddressError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading House Front And Address: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.HouseFrontAndAddress)}><FontAwesomeIcon icon={faCircle} /> House Front And Address</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="HouseFrontAndAddress" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="HouseFrontAndAddress" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'HouseFrontAndAddress', 'HouseFrontAndAddressError')} /></td>
                                    <td className="w-25"><label for="HouseFrontAndAddressUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="HouseFrontAndAddressUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'HouseFrontAndAddress', 'HouseFrontAndAddressError')}/></td>
                                </tr>

                                {/* House Front And Address Array Photos */}
                                {
                                    this.state.HouseFrontAndAddressArray.length !== 0 ? 
                                    
                                    this.state.HouseFrontAndAddressArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another House Front And Address Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('HouseFrontAndAddressArray', 'HouseFrontAndAddress-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Attic And Rafters Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.AtticAndRaftersError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Attic And Rafters Photos: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Attic And Rafters</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="AtticAndRaftersUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="AtticAndRaftersUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'AtticAndRaftersArray', 'AtticAndRafters-','AtticAndRaftersError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.AtticAndRaftersArray.length !== 0 ? 
                                    
                                    this.state.AtticAndRaftersArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Tilt Screenshot Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.TiltScreenshot).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Tilt Screenshot</div>
                                            :
                                            this.state.TiltScreenshotError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Tilt Screenshot: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.TiltScreenshot)}><FontAwesomeIcon icon={faCircle} /> Tilt Screenshot</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="TiltScreenshot" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="TiltScreenshot" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'TiltScreenshot', 'TiltScreenshotError')} /></td>
                                    <td className="w-25"><label for="TiltScreenshotUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="TiltScreenshotUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'TiltScreenshot', 'TiltScreenshotError')}/></td>
                                </tr>

                                {/* Tilt Screenshot Array Photos */}
                                {
                                    this.state.TiltScreenshotArray.length !== 0 ? 
                                    
                                    this.state.TiltScreenshotArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Tilt Screenshot Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('TiltScreenshotArray', 'TiltScreenshot-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Sub Panel Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.SubPanelError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Sub Panel Photos: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Sub Panel Photos</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="SubPanelUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="SubPanelUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'SubPanelArray', 'SubPanel-','SubPanelError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.SubPanelArray.length !== 0 ? 
                                    
                                    this.state.SubPanelArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Garage Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.GarageError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Garage Photos: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Garage</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="GarageUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="GarageUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'GarageArray', 'Garage-','GarageError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.GarageArray.length !== 0 ? 
                                    
                                    this.state.GarageArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Ceiling Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.Ceiling).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Ceiling</div>
                                            :
                                            this.state.CeilingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Ceiling: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.Ceiling)}><FontAwesomeIcon icon={faCircle} /> Ceiling</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="Ceiling" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="Ceiling" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'Ceiling', 'CeilingError')} /></td>
                                    <td className="w-25"><label for="CeilingUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CeilingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'Ceiling', 'CeilingError')}/></td>
                                </tr>

                                {/* MSPStandbackAndWeatherhead Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.MSPStandbackAndWeatherheadError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Standback And Weatherhead: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Standback And Weatherhead</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="MSPStandbackAndWeatherheadUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="MSPStandbackAndWeatherheadUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'MSPStandbackAndWeatherheadArray', 'MSPStandbackAndWeatherhead-','MSPStandbackAndWeatherheadError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.MSPStandbackAndWeatherheadArray.length !== 0 ? 
                                    
                                    this.state.MSPStandbackAndWeatherheadArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Gas Riser Measurement Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.GasRiserMeasurement).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Gas Riser Measurement</div>
                                            :
                                            this.state.GasRiserMeasurementError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Gas Riser Measurement: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.GasRiserMeasurement)}><FontAwesomeIcon icon={faCircle} /> Gas Riser Measurement</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="GasRiserMeasurement" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="GasRiserMeasurement" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'GasRiserMeasurement', 'GasRiserMeasurementError')} /></td>
                                    <td className="w-25"><label for="GasRiserMeasurementUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="GasRiserMeasurementUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'GasRiserMeasurement', 'GasRiserMeasurementError')}/></td>
                                </tr>

                                {/* Meter Close Up Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MeterCloseUp).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Meter Close Up</div>
                                            :
                                            this.state.MeterCloseUpError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Meter Close Up: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MeterCloseUp)}><FontAwesomeIcon icon={faCircle} /> Meter Close Up</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MeterCloseUp" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MeterCloseUp" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MeterCloseUp', 'MeterCloseUpError')} /></td>
                                    <td className="w-25"><label for="MeterCloseUpUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MeterCloseUpUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MeterCloseUp', 'MeterCloseUpError')}/></td>
                                </tr>

                                {/* Meter Close Up Array Photos */}
                                {
                                    this.state.MeterCloseUpArray.length !== 0 ? 
                                    
                                    this.state.MeterCloseUpArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Meter Close Up Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('MeterCloseUpArray', 'MeterCloseUp-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* MSP Close Ups Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.MSPCloseUpsError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Close Ups: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Close Ups</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="MSPCloseUpsUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="MSPCloseUpsUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'MSPCloseUpsArray', 'MSPCloseUps-','MSPCloseUpsError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.MSPCloseUpsArray.length !== 0 ? 
                                    
                                    this.state.MSPCloseUpsArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Whole House Wall Space Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.WholeHouseWallSpaceError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Whole House Wall Space: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Whole House Wall Space</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="WholeHouseWallSpaceUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="WholeHouseWallSpaceUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'WholeHouseWallSpaceArray', 'WholeHouseWallSpace-','WholeHouseWallSpaceError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.WholeHouseWallSpaceArray.length !== 0 ? 
                                    
                                    this.state.WholeHouseWallSpaceArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Battery Clearance Measurement Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.BatteryClearanceMeasurement).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Battery Clearance Measurement</div>
                                            :
                                            this.state.BatteryClearanceMeasurementError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Battery Clearance Measurement: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.BatteryClearanceMeasurement)}><FontAwesomeIcon icon={faCircle} /> Battery Clearance Measurement</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="BatteryClearanceMeasurement" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="BatteryClearanceMeasurement" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'BatteryClearanceMeasurement', 'BatteryClearanceMeasurementError')} /></td>
                                    <td className="w-25"><label for="BatteryClearanceMeasurementUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="BatteryClearanceMeasurementUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'BatteryClearanceMeasurement', 'BatteryClearanceMeasurementError')}/></td>
                                </tr>

                                {/* Battery Clearance Measurement Array Photos */}
                                {
                                    this.state.BatteryClearanceMeasurementArray.length !== 0 ? 
                                    
                                    this.state.BatteryClearanceMeasurementArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Battery Clearance Measurement Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('BatteryClearanceMeasurementArray', 'BatteryClearanceMeasurement-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Exterior Grounding Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ExteriorGrounding).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Exterior Grounding</div>
                                            :
                                            this.state.ExteriorGroundingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Exterior Grounding: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ExteriorGrounding)}><FontAwesomeIcon icon={faCircle} /> Exterior Grounding</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ExteriorGrounding" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ExteriorGrounding" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ExteriorGrounding', 'ExteriorGroundingError')} /></td>
                                    <td className="w-25"><label for="ExteriorGroundingUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ExteriorGroundingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ExteriorGrounding', 'ExteriorGroundingError')}/></td>
                                </tr>

                                {/* Exterior Grounding Array Photos */}
                                {
                                    this.state.ExteriorGroundingArray.length !== 0 ? 
                                    
                                    this.state.ExteriorGroundingArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Exterior Grounding Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ExteriorGroundingArray', 'ExteriorGrounding-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* DigTicketMarking Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.DigTicketMarking).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Dig Ticket Marking</div>
                                            :
                                            this.state.DigTicketMarkingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Dig Ticket Marking: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.DigTicketMarking)}><FontAwesomeIcon icon={faCircle} /> Exterior Grounding</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="DigTicketMarking" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="DigTicketMarking" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'DigTicketMarking', 'DigTicketMarkingError')} /></td>
                                    <td className="w-25"><label for="DigTicketMarkingUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="DigTicketMarkingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'DigTicketMarking', 'DigTicketMarkingError')}/></td>
                                </tr>

                                {/* DigTicketMarking Array Photos */}
                                {
                                    this.state.DigTicketMarkingArray.length !== 0 ? 
                                    
                                    this.state.DigTicketMarkingArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Dig Ticket Marking Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('DigTicketMarkingArray', 'DigTicketMarking-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Roof and Horizon Photos Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.RoofAndHorizonPhotosError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Roof and Horizon Photos: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Roof and Horizon Photos</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="RoofAndHorizonPhotosUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="RoofAndHorizonPhotosUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'RoofAndHorizonPhotosArray', 'RoofAndHorizonPhotos-','RoofAndHorizonPhotosError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.RoofAndHorizonPhotosArray.length !== 0 ? 
                                    
                                    this.state.RoofAndHorizonPhotosArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Ground Mount Area Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.GroundMountAreaError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Ground Mount Area: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Ground Mount Area</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="GroundMountAreaUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="GroundMountAreaUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'GroundMountAreaArray', 'GroundMountArea-','GroundMountAreaError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.GroundMountAreaArray.length !== 0 ? 
                                    
                                    this.state.GroundMountAreaArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Ground Mount Video */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.GroundMountVideo).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Ground Mount Video</div>
                                            :
                                            this.state.GroundMountVideoError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Ground Mount Video: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-green'><FontAwesomeIcon icon={faCircle} /> <a className='text-green' href={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/photo-pack/${this.opportunityId}/siteSurvey/GroundMountVideo.mp4`} target="_blank">Ground Mount Video</a></div>
                                        }
                                    </td>
                                    <td className="w-25"><label for="GroundMountVideoUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="GroundMountVideoUpload" type="file" accept="video/mp4,video/x-m4v,video/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'GroundMountVideo', 'GroundMountVideoError')}/></td>
                                    <td></td>
                                </tr>

                                {/* Trench Path Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.TrenchPathError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Trench Path: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Trench Path</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="TrenchPathUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="TrenchPathUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'TrenchPathArray', 'TrenchPath-','TrenchPathError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.TrenchPathArray.length !== 0 ? 
                                    
                                    this.state.TrenchPathArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                                {/* Misceallaneous (A/C, Well, MFD HUD, MFD Decal, MFD Foundation) Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.MisceallaneousError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Misceallaneous (A/C, Well, MFD HUD, MFD Decal, MFD Foundation): <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Misceallaneous (A/C, Well, MFD HUD, MFD Decal, MFD Foundation)</div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label for="MisceallaneousUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div> Bulk Upload</label>
                                        <input className={css.PhotoPack__PicInput} id="MisceallaneousUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.bulkUpload(event.target.files, 'MisceallaneousArray', 'Misceallaneous-','MisceallaneousError')}/>
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                    this.state.MisceallaneousArray.length !== 0 ? 
                                    
                                    this.state.MisceallaneousArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }

                            </tbody>
                        </table>

                        {/* Slack div to send messages */}
                        {/* <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div> */}
                    </div>
                }

                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>

            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(SiteSurveyPhotoPack);